export default __webpack_public_path__ + "static/media/learn_info.b5f670aa.png";